module.exports = __webpack_public_path__ + "static/media/AddAssignee.9c191ba3.svg";